module.exports = __webpack_public_path__ + "static/img/bg.9dd58ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/4/bg.png
// module id = z3Wb
// module chunks = 2